import * as Sentry from '@sentry/angular';

export const SentryInstance = Sentry;

export function captureSentryException(name: string = '', error: any = {}, inputData: any = {}): string {
  const sentryData: SentryIssueData = { name, error, inputData };
  sendToSentry('info', sentryData); // TODO: Need to figure out correct err obj
  return 'Sent exception to Sentry';
}

export function captureSentryMessage(name: string, error: any = {}, inputData: any = {}): string {
  const sentryData: SentryIssueData = { name, error, inputData };
  sendToSentry('info', sentryData);
  return 'Sent message to Sentry';
}

export interface FormErrorApiResponse {
  status_code: number;
  detail?: string;
  details?: Record<string, string[]>;
  message?: string;
}

type SentryIssueType = 'exception' | 'info';
type SentryIssueData = {
  name: string;
  error?: FormErrorApiResponse;
  inputData?: any;
};

const sendToSentry = (type: SentryIssueType, data: SentryIssueData): void => {
  const sentryFunc = type === 'exception' ? SentryInstance.captureException : SentryInstance.captureMessage;
  const errorName = data.name;
  const errorData = data.error as any;
  const inputData = maskPasswords(data.inputData);
  try {
    const errMsg: string[] = [errorName];
    if (Object.keys(errorData).length) {
      const errDataStr = JSON.stringify(errorData);
      errMsg.push(`ERROR_DATA=${errDataStr}`);
    }
    if (Object.keys(inputData).length) {
      const inputDataStr = JSON.stringify(inputData);
      errMsg.push(`INPUT_DATA=${inputDataStr}`);
    }
    sentryFunc(errMsg.join(', '));
  } catch (e) {
    sentryFunc(errorName, errorData);
  }
};

function maskPasswords(obj: any, i = 0): any {
  if (typeof obj !== 'object' || obj === null) {
    return obj;
  }

  for (const key in obj) {
    if (key === 'password') {
      delete obj[key];
    } else if (typeof obj[key] === 'object') {
      if (i > 30) {
        return obj;
      }
      maskPasswords(obj[key], i++);
    }
  }

  return obj;
}
